import { ForgotPasswordContent } from "./ForgotPasswordContent"

export function ForgotPassword() {
  return (
    <ForgotPasswordContent
      backRoute="/"
      doneRoute="/"
    />
  )
}
